module.exports = __webpack_public_path__ + "img/sc-logo-2.9de91320.png";